module.exports = __webpack_public_path__ + "img/logo-vistat-white.b4b95b2.png";